/**
 * Common setup shared between all apps. Must be called by all apps
 */
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
// Import Vue from 'vue';
// Import VueMeta from 'vue-meta';
// Import { IS_DEV } from '@console/constants/config';

dayjs.extend(utc);
dayjs.extend(isoWeek);
dayjs.extend(duration);
dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

// Vue.config.productionTip = false;
// Vue.config.performance = IS_DEV;
// Vue.config.devtools = IS_DEV;

// Vue.use(VueMeta);
